import type { Row } from './RiskIndicators';

// Identifier values that mean "no resolved DIN/CIN". A missing identifier is
// serialised as one of these literal strings (all truthy), so a plain
// `row.identifier ? …` check wrongly treats them as real.
const NULL_IDENTIFIER_SENTINELS = ['null', 'undefined'];

/**
 * Builds the mutually-exclusive lookup key for the regulatory-risk-hits query:
 * `{ identifier }` when the row carries a real identifier, else `{ entityName }`.
 * An entity screened without a resolved DIN/CIN has no identifier — the data
 * surfaces that as `"null"`/`"undefined"`/blank — so sending it as `identifier`
 * resolves to the wrong/absent entity and the drawer comes back empty. Kept in
 * sync with the backend's NULL_IDENTIFIER_SENTINELS normalization.
 */
export function resolveEntityQueryKey(row?: Pick<Row, 'identifier' | 'name'>): { identifier: string } | { entityName: string } {
    const idf = (row?.identifier ?? '').trim();
    const hasIdentifier = idf !== '' && !NULL_IDENTIFIER_SENTINELS.includes(idf.toLowerCase());
    return hasIdentifier ? { identifier: idf } : { entityName: row?.name ?? '' };
}
